// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "pages-Success-Success" + "-" + "b5eb0d2bd16d7757d146" + ".css";
};